var _rect, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSku360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#1976d2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5L13 22.5L21 13.5",
    stroke: "#ffffff",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 25,
    fontFamily: "'Segoe UI', Roboto, -apple-system, sans-serif",
    fontSize: 20,
    fontWeight: 800,
    letterSpacing: -0.3
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#1e293b"
  }, "SKU"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#1976d2"
  }, "360"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSku360);
export default __webpack_public_path__ + "static/media/SKU360.4f471e130d11cb5799a9393c35208fa6.svg";
export { ForwardRef as ReactComponent };